import common from '../components/common.js';

export default{
   saveUser: function(user){
      if(user){
         if(user.id && user.id !== ''){
            common.setLocalStorage("book_iE3eF5wq438ra",user.id,72);
         }
         if(user.nickName && user.nickName !== ''){
            common.setLocalStorage("book_iE3eF5wq438rb",user.nickName,72);
         }
         if(user.headUrl && user.headUrl !== ''){
            common.setLocalStorage("book_iE3eF5wq438rc",user.headUrl,72);
         }
      }
   },
   setUserNickName:function (nickName){
      if(nickName && nickName !== ''){
         common.setLocalStorage("book_iE3eF5wq438rb",nickName,72);
      }
   },
   getUserId: function(){
     return common.getLocalStorage("book_iE3eF5wq438ra");
   },
   getUserNickname: function(){
     return common.getLocalStorage("book_iE3eF5wq438rb");
   },
   setUserHeadUrl:function (headUrl){
      if(headUrl && headUrl !== ''){
         common.setLocalStorage("book_iE3eF5wq438rc",headUrl,72);
      }
   },
   getUserHeadUrl: function(){
     return common.getLocalStorage("book_iE3eF5wq438rc");
   },
   logout:function (){
      localStorage.removeItem("book_iE3eF5wq438ra");
      localStorage.removeItem("book_iE3eF5wq438rb");
      localStorage.removeItem("book_iE3eF5wq438rc");
   },
   setUserLastRouter(pathName){
      if(pathName && pathName !== ''){
         common.setSessionStorage("book_iqDacSqDadfE",pathName,30);
      }
   },
   getUserLastRouter(){
      return common.getSessionStorage("book_iqDacSqDadfE");
   },
   setBHeight(height){
      if(height !== 'undefined' && height !== ''){
         common.setSessionStorage("book_iBqhEIGHTdfE",height,30);
      }
   },
   getBHeight(){
      return common.getSessionStorage("book_iBqhEIGHTdfE");
   },
   setDHeight(height){
      if(height !== 'undefined' && height !== ''){
         common.setSessionStorage("book_iDqhEIGHTdfE",height,30);
      }
   },
   getDHeight(){
      return common.getSessionStorage("book_iDqhEIGHTdfE");
   }
}



// WEBPACK FOOTER //
// ./src/utils/user.js